import { useState } from "react";
import MarketMoney from "./components/MarketMoney";
import StoreRequestsList from "./components/StoreRequestsList";
import OrdersList from "./components/OrdersList";

export default function MarketDashboard() {
  const [changeTable, setChangeTable] = useState(0);

  const renderTab = () => {
    switch (changeTable) {
      case 0:
        // MarketMoney covers everything the old MarketOverview showed
        // (status counts, GMV, commission accrued/collected/outstanding)
        // plus the date range, the per-store split and the rates.
        return <MarketMoney />;
      case 1:
        return <StoreRequestsList defaultStatus="pending" />;
      case 2:
        return <StoreRequestsList defaultStatus="approved" showWalletFilter />;
      case 3:
        return <OrdersList />;
      default:
        return null;
    }
  };

  return (
    <>
      <div data-aos="fade-down" data-aos-duration="800"></div>
      <div>
        <div
          className="mt-3 d-flex align-items-center justify-content-evenly text-white mb-5"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <h3
            onClick={() => setChangeTable(0)}
            className={`fw-bold pointer text-grey ${
              changeTable === 0 && "active-table"
            }`}
            data-aos="zoom-in"
            data-aos-duration="600"
            data-aos-delay="400"
          >
            Overview
          </h3>
          <h3
            onClick={() => setChangeTable(1)}
            className={`fw-bold pointer text-grey ${
              changeTable === 1 && "active-table"
            }`}
            data-aos="zoom-in"
            data-aos-duration="600"
            data-aos-delay="500"
          >
            Store Requests
          </h3>
          <h3
            onClick={() => setChangeTable(2)}
            className={`fw-bold pointer text-grey ${
              changeTable === 2 && "active-table"
            }`}
            data-aos="zoom-in"
            data-aos-duration="600"
            data-aos-delay="600"
          >
            Stores
          </h3>
          <h3
            onClick={() => setChangeTable(3)}
            className={`fw-bold pointer text-grey ${
              changeTable === 3 && "active-table"
            }`}
            data-aos="zoom-in"
            data-aos-duration="600"
            data-aos-delay="700"
          >
            Orders
          </h3>
        </div>
        <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="600">
          {renderTab()}
        </div>
      </div>
    </>
  );
}
